import { lazy, Suspense } from "react";
import Header from "../Header/Header";
import Hero from "../Hero/Hero";
import { HOME_FAQS } from "../HomeFAQ/HomeFAQ";
import Seo from "../components/Seo";
import DeferredSection from "../components/DeferredSection";
import { generateAggressiveSeoMetaTags, generateAreaServedSchema, generateEducationalOrganizationSchema } from "../utils/aggressiveSeo";

const Footer = lazy(() => import("../Footer/Footer"));
const UniversityStory = lazy(() => import("../UniversityStory/UniversityStory"));
const Programmes = lazy(() => import("../HomeProgrammes/Programmes"));
const WhyChoose = lazy(() => import("../WhyChoose/WhyChoose"));
const StatsSection = lazy(() => import("../Stats/StatsSection"));
const StudentLife = lazy(() => import("../StudentLife/StudentLife"));
const Schools = lazy(() => import("../Our Schools/Schools"));
const InstitutesSection = lazy(() => import("../Institutes/Institutes"));
const Partners = lazy(() => import("../Partners/Partners"));
const Testimonials = lazy(() => import("../Testimonials/Testimonials"));
const RecentEvents = lazy(() => import("../RecentEvents/RecentEvents"));
const UpcomingEvents = lazy(() => import("../UpcomingEvents/Upcomingevents"));
const BlogSection = lazy(() => import("../Blogs/BlogSection"));
const HomeFAQ = lazy(() => import("../HomeFAQ/HomeFAQ"));
const NewsletterSection = lazy(() => import("../Newsletters/Newsletters"));

const Deferred = ({ children, minHeight }) => (
  <DeferredSection minHeight={minHeight}>
    <Suspense fallback={null}>{children}</Suspense>
  </DeferredSection>
);

function Landingpage() {
  const aggressiveSeo = generateAggressiveSeoMetaTags(
    "Zetech University",
    "Chartered private university in Kenya offering Degree, Masters, PhD, Diploma, Certificate and TVET programmes. January, May and September intakes, flexible study options and online applications. Leading technology university in Nairobi serving Kenyan, East African, African, and international students with world-class education.",
    ["private university in Kenya", "universities in Kenya", "Zetech University", "degree courses Kenya", "diploma courses", "TVET Kenya", "masters programmes Kenya", "PhD Kenya", "university intake Kenya", "apply to university online"]
  );

  const areaServedSchema = generateAreaServedSchema();
  const eduOrgSchema = generateEducationalOrganizationSchema();

  return (
    <>
      <Seo
        rawTitle={aggressiveSeo.title}
        description={aggressiveSeo.description}
        keywords={aggressiveSeo.keywords}
        path="/"
        ogTitle={aggressiveSeo.ogTitle}
        ogDescription={aggressiveSeo.ogDescription}
        twitterTitle={aggressiveSeo.twitterTitle}
        targetRegion={aggressiveSeo.targetRegion}
        targetCountry={aggressiveSeo.targetCountry}
        targetAudience={aggressiveSeo.targetAudience}
        marketRegion={aggressiveSeo.marketRegion}
        marketTarget={aggressiveSeo.marketTarget}
        globalReach={aggressiveSeo.globalReach}
        universityType={aggressiveSeo.universityType}
        universityCategory={aggressiveSeo.universityCategory}
        universityRanking={aggressiveSeo.universityRanking}
        accreditation={aggressiveSeo.accreditation}
        international={aggressiveSeo.international}
        studyDestination={aggressiveSeo.studyDestination}
        jsonLd={[
          {
            "@type": "FAQPage",
            "@id": "https://www.zetech.ac.ke/#faq",
            mainEntity: HOME_FAQS.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: { "@type": "Answer", text: faq.answer },
            })),
          },
          areaServedSchema,
          eduOrgSchema,
        ]}
      />
      <Header />
      <Hero />
      <Deferred minHeight={480}><UniversityStory /></Deferred>
      <Deferred minHeight={600}><Programmes /></Deferred>
      <Deferred minHeight={480}><WhyChoose /></Deferred>
      <Deferred minHeight={420}><Schools /></Deferred>
      <Deferred minHeight={480}><StudentLife /></Deferred>
      <Deferred minHeight={380}><StatsSection /></Deferred>
      <Deferred minHeight={420}><InstitutesSection /></Deferred>
      <Deferred minHeight={300}><Partners /></Deferred>
      <Deferred minHeight={480}><Testimonials /></Deferred>
      <Deferred minHeight={420}><RecentEvents /></Deferred>
      <Deferred minHeight={420}><UpcomingEvents /></Deferred>
      <Deferred minHeight={420}><BlogSection /></Deferred>
      <Deferred minHeight={480}><HomeFAQ /></Deferred>
      <Deferred minHeight={360}><NewsletterSection /></Deferred>
      <Deferred minHeight={360}><Footer /></Deferred>
    </>
  );
}

export default Landingpage;
